module.exports = __webpack_public_path__ + "static/media/Maui3.63cf0a89.webp";